import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-event-card-placeholder',
    templateUrl: './event-card-placeholder.component.html',
    styleUrls: ['./event-card-placeholder.component.css'],
    standalone: false
})
export class EventCardPlaceholderComponent {
  @Input("border") border!: boolean;

  constructor() {}
}
